// Verwaltungsobjekt: Wer sieht die internen Unterlagen? (Patrick 18.10.2026: zunächst nur Admins,
// per Knopfdruck für alle Mitarbeiter freigebbar.) Durchgesetzt in der Datenbank (darf_verwaltung_sehen,
// RLS) und in der Edge Function gdrive; hier nur Lesen/Schreiben des Schalters.
import { supabase } from '../supabase/client';

export const VERWALTUNG_SICHTBARKEIT_KEY = 'verwaltung_sichtbarkeit';

export const VERWALTUNG_ERKLAERUNG = {
  titel: 'Verwaltung – interne Unterlagen',
  was: 'Hier liegen Unterlagen der Hausverwaltung selbst: Rechnungen ans Büro, Steuern, Versicherungen, Fahrzeuge, IT, Verträge, Personal. Es ist kein verwaltetes Objekt und erscheint deshalb nicht in Objektliste, Kennzahlen, Mietern oder Eigentümern.',
  sichtbar: (alle: boolean) => (alle ? 'Sichtbar für alle Mitarbeiter.' : 'Sichtbar nur für Admins.'),
  nicht: 'Der Schalter regelt den Zugriff in der App. Wer im Google Drive selbst direkten Zugriff auf die Ablage hat, sieht den Ordner dort unabhängig davon.',
};

/** Nur ausdrücklich true gibt für alle frei. */
export function leseSichtbarkeit(wert: unknown): { alle: boolean } {
  const o = wert && typeof wert === 'object' && !Array.isArray(wert) ? wert as Record<string, unknown> : {};
  return { alle: o.alle === true };
}

export async function ladeSichtbarkeit(): Promise<{ alle: boolean }> {
  const { data, error } = await supabase.from('app_settings').select('value').eq('key', VERWALTUNG_SICHTBARKEIT_KEY).maybeSingle();
  if (error) throw error;
  return leseSichtbarkeit(data?.value);
}

export async function speichereSichtbarkeit(alle: boolean): Promise<void> {
  const { error } = await supabase.from('app_settings').upsert(
    { key: VERWALTUNG_SICHTBARKEIT_KEY, value: { alle }, updated_at: new Date().toISOString() },
    { onConflict: 'key' },
  );
  if (error) throw error;
}
